export const GOOGLE_API_KEY = "AIzaSyBMVUVUvF7H8eO9k2PXZpQZ4d3ld6yg83s"